import { setTerms } from './helpers';

export const setBuildingCranageTypesType = setTerms('building_cranage_types_type');
